import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "./CtaBand.css";
import contactContext from "../../../context/contact/contactcontext";

function CtaBand() {
  const { contactInfo } = useContext(contactContext);
  const phone = contactInfo && contactInfo.phone ? JSON.parse(contactInfo.phone) : { phone: "080 2334 7276" };

  return (
    <section className="band cta-band">
      <div className="wrap">
        <div className="cta-inner">
          <div>
            <h2>You will find love and support at every step of your pregnancy.</h2>
            <p>
              Book a consultation and see the centre for yourself &mdash; the rooms, the team, and the people who will be with you on the day.
            </p>
          </div>
          <div className="cta-actions">
            <Link className="btn-light" to="/appointment">
              Book an appointment
            </Link>
            <a className="btn-outline-light" href={`tel:${phone.phone ? phone.phone.replace(/\s+/g, '') : "08023347276"}`}>
              Call {phone.phone || "080 2334 7276"}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaBand;

